var map = {
	"./Spin360_TorreOvaloA_001.jpg": 38,
	"./Spin360_TorreOvaloA_002.jpg": 81544,
	"./Spin360_TorreOvaloA_003.jpg": 1985,
	"./Spin360_TorreOvaloA_004.jpg": 61348,
	"./Spin360_TorreOvaloA_005.jpg": 59437,
	"./Spin360_TorreOvaloA_006.jpg": 64901,
	"./Spin360_TorreOvaloA_007.jpg": 45404,
	"./Spin360_TorreOvaloA_008.jpg": 20534,
	"./Spin360_TorreOvaloA_009.jpg": 56555,
	"./Spin360_TorreOvaloA_010.jpg": 55367,
	"./Spin360_TorreOvaloA_011.jpg": 70594,
	"./Spin360_TorreOvaloA_012.jpg": 95537,
	"./Spin360_TorreOvaloA_013.jpg": 95965,
	"./Spin360_TorreOvaloA_014.jpg": 86791,
	"./Spin360_TorreOvaloA_015.jpg": 13607,
	"./Spin360_TorreOvaloA_016.jpg": 24521,
	"./Spin360_TorreOvaloA_017.jpg": 12087,
	"./Spin360_TorreOvaloA_018.jpg": 47152,
	"./Spin360_TorreOvaloA_019.jpg": 93340,
	"./Spin360_TorreOvaloA_020.jpg": 5506,
	"./Spin360_TorreOvaloA_021.jpg": 91934,
	"./Spin360_TorreOvaloA_022.jpg": 93788,
	"./Spin360_TorreOvaloA_023.jpg": 21836,
	"./Spin360_TorreOvaloA_024.jpg": 5689,
	"./Spin360_TorreOvaloA_025.jpg": 46419,
	"./Spin360_TorreOvaloA_026.jpg": 726,
	"./Spin360_TorreOvaloA_027.jpg": 63388,
	"./Spin360_TorreOvaloA_028.jpg": 58179,
	"./Spin360_TorreOvaloA_029.jpg": 11964,
	"./Spin360_TorreOvaloA_030.jpg": 5997,
	"./Spin360_TorreOvaloA_031.jpg": 62552,
	"./Spin360_TorreOvaloA_032.jpg": 21312,
	"./Spin360_TorreOvaloA_033.jpg": 99415,
	"./Spin360_TorreOvaloA_034.jpg": 33418,
	"./Spin360_TorreOvaloA_035.jpg": 65013,
	"./Spin360_TorreOvaloA_036.jpg": 8021,
	"./Spin360_TorreOvaloA_037.jpg": 61361,
	"./Spin360_TorreOvaloA_038.jpg": 26168,
	"./Spin360_TorreOvaloA_039.jpg": 75975,
	"./Spin360_TorreOvaloA_040.jpg": 94199,
	"./Spin360_TorreOvaloA_041.jpg": 73935,
	"./Spin360_TorreOvaloA_042.jpg": 69372,
	"./Spin360_TorreOvaloA_043.jpg": 28211,
	"./Spin360_TorreOvaloA_044.jpg": 17680,
	"./Spin360_TorreOvaloA_045.jpg": 70674,
	"./Spin360_TorreOvaloA_046.jpg": 81131,
	"./Spin360_TorreOvaloA_047.jpg": 28575,
	"./Spin360_TorreOvaloA_048.jpg": 9541,
	"./Spin360_TorreOvaloA_049.jpg": 37301,
	"./Spin360_TorreOvaloA_050.jpg": 95610,
	"./Spin360_TorreOvaloA_051.jpg": 90716,
	"./Spin360_TorreOvaloA_052.jpg": 55383,
	"./Spin360_TorreOvaloA_053.jpg": 5468,
	"./Spin360_TorreOvaloA_054.jpg": 89478,
	"./Spin360_TorreOvaloA_055.jpg": 7707,
	"./Spin360_TorreOvaloA_056.jpg": 28897,
	"./Spin360_TorreOvaloA_057.jpg": 66932,
	"./Spin360_TorreOvaloA_058.jpg": 80594,
	"./Spin360_TorreOvaloA_059.jpg": 77079,
	"./Spin360_TorreOvaloA_060.jpg": 94110,
	"./Spin360_TorreOvaloA_061.jpg": 52079,
	"./Spin360_TorreOvaloA_062.jpg": 92296,
	"./Spin360_TorreOvaloA_063.jpg": 12216,
	"./Spin360_TorreOvaloA_064.jpg": 33472,
	"./Spin360_TorreOvaloA_065.jpg": 57055,
	"./Spin360_TorreOvaloA_066.jpg": 64831,
	"./Spin360_TorreOvaloA_067.jpg": 35045,
	"./Spin360_TorreOvaloA_068.jpg": 39184,
	"./Spin360_TorreOvaloA_069.jpg": 83842,
	"./Spin360_TorreOvaloA_070.jpg": 70977,
	"./Spin360_TorreOvaloA_071.jpg": 64778,
	"./Spin360_TorreOvaloA_072.jpg": 99662
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34732;